<template>
  <v-container class="ranking">
    <div class="ma-5">
      <h3 class="text-center">{{ $t('ranking.title') }}</h3>
      <!-- <v-row class="ma-5">
        <v-spacer></v-spacer>

        <v-dialog width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn :disabled="result == null" color="amber" v-bind="attrs" v-on="on" rounded>
              決定！
            </v-btn>
          </template>

<v-card>
  <v-card-title class="blue lighten-2 white--text">
    どちらか選んでください
  </v-card-title>
  <v-divider></v-divider>
  <v-card-actions>
    <v-btn color="primary" text @click="sendDB('/draw-penguin')">
      他のペンギンを描く
    </v-btn>
  </v-card-actions>
  <v-card-actions>
    <v-btn color="primary" text @click="sendDB('/form')">
      他の場所で描く
    </v-btn>
  </v-card-actions>
</v-card>
</v-dialog>
</v-row> -->
    </div>



    <v-card v-for="(pen, index) of limitCount" :key="index" @click="setResultRank(index)" class="ma-5 rounded-xl card"
      height="160" shaped color="#E3F2FD">
      <!-- <v-card v-for="(pen, index) of limitCount" :key="index" @click="setResultRank(index)" class="ma-5 rounded-xl"
      height="160" shaped :color="result == index + 1 ? 'primary' : ''"> -->
      <div class="d-flex">
        <div>
          <v-img width="110" height="160" :src="pen.picture" class="rounded-left"></v-img>
        </div>
        <div class="item">
          <h3 class="mt-3 ml-3">{{ index + 1 }}:{{ pen.nameLabel }}
            <v-icon v-for="(color, index) in pen.band_color" :style="{ color: color + ' !important' }"
              :key="index">mdi-circle
            </v-icon>
          </h3>
          <v-col>
            <p class="comment">
              <!-- <span v-if="pen.genderLabel">{{ pen.genderLabel }}</span>
              {{ $t('ranking.birthday', { date: pen.birthdayLabel }) }}
              <span v-if="pen.pairLabel">{{ $t('ranking.pair', { name: pen.pairLabel }) }}</span>
              {{ $t('ranking.place', { place: pen.placeLabel }) }}
              {{ pen.comment }} -->
              <span v-if="pen.genderLabel">
                {{ pen.genderLabel }}
              </span>
              <span v-if="pen.birthdayLabel">
                {{ $t('ranking.birthday', { date: pen.birthdayLabel }) }}
              </span>
              <span v-if="pen.pairLabel">
                {{ $t('ranking.pair', { name: pen.pairLabel }) }}
              </span>
              <span v-if="pen.placeLabel">
                {{ $t('ranking.place', { place: pen.placeLabel }) }}
              </span>
              <span v-if="pen.comment">
                {{ pen.comment }}<br />
              </span>
            </p>
          </v-col>
        </div>
      </div>
    </v-card>

    <v-row justify="center">
      <v-btn v-show="!(isShowMore)" @click="showMore()" text color="primary">{{ $t('ranking.notHere') }}</v-btn>
    </v-row>

    <v-card v-show="isShowMore" v-for="(pen, index) of elseCount" :key="pen.name" @click="setResultRank(index + 7)"
      class="ma-5 rounded-xl" height="160" shaped color="#E3F2FD">
      <!-- <v-card v-show="isShowMore" v-for="(pen, index) of elseCount" :key="pen.name" @click="setResultRank(index + 7)"
      class="ma-5 rounded-xl" height="160" shaped :color="result == index + 1 ? 'primary' : ''"> -->
      <div class="d-flex">
        <div>
          <v-img width="110" height="160" :src="pen.picture" class="rounded-left"></v-img>
        </div>
        <div class="item">
          <h3 class="mt-3 ml-3">{{ index + 8 }}:{{ pen.nameLabel }}
            <v-icon v-for="(color, index) in pen.band_color" :style="{ color: color + ' !important' }"
              :key="index">mdi-circle
            </v-icon>
          </h3>
          <v-col>
            <p class="comment">
              <!-- <span v-if="pen.genderLabel">{{ pen.genderLabel }}</span>
              {{ $t('ranking.birthday', { date: pen.birthdayLabel }) }}
              <span v-if="pen.pairLabel">{{ $t('ranking.pair', { name: pen.pairLabel }) }}</span>
              {{ $t('ranking.place', { place: pen.placeLabel }) }}
              {{ pen.comment }} -->
              <span v-if="pen.genderLabel">
                {{ pen.genderLabel }}
              </span>
              <span v-if="pen.birthdayLabel">
                {{ $t('ranking.birthday', { date: pen.birthdayLabel }) }}
              </span>
              <span v-if="pen.pairLabel">
                {{ $t('ranking.pair', { name: pen.pairLabel }) }}
              </span>
              <span v-if="pen.placeLabel">
                {{ $t('ranking.place', { place: pen.placeLabel }) }}
              </span>
              <span v-if="pen.comment">
                {{ pen.comment }}<br />
              </span>
            </p>
          </v-col>
        </div>
      </div>
    </v-card>

    <v-row justify="center" class="ma-5">

    </v-row>

    <v-row justify="center" class="ma-5">
      <v-dialog width="500">
        <template v-slot:activator="{ on, attrs }">
          <!-- <v-btn v-show="isShowMore" :color="result == 0 ? 'primary' : ''" @click="notSure()" rounded> -->
          <v-btn v-show="isShowMore" color="gray" rounded v-bind="attrs" v-on="on" @click="notSure()">
            {{ $t('ranking.notSure') }}
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="blue lighten-2 white--text">
            {{ $t('ranking.chooseOne') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="sendDB('draw-penguin')">
              {{ $t('ranking.drawOther') }}
            </v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-btn color="primary" text @click="sendDB('')">
              {{ $t('ranking.goHome') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- <div class="reference ma-5">
      【引用】
      <li>すみだ水族館．「すみだペンギン相関図2023」．https://www.sumida-aquarium.com/sokanzu/2023sokanzu/, (参照 2023-10-01)</li>
      <li>すみだ水族館．「推しペン診断 ペンギン一覧」．https://www.sumida-aquarium.com/oshi-pen/list.html, (参照 2023-10-01)</li>
    </div> -->
  </v-container>
</template>


<script>
import { fire, getPrevScreen, setCurrentScreen } from '@/utils/logger';

export default {
  props: ['aquarium'], // ルーターから受け取るプロップス
  data() {
    return {
      // pens: [],
      result: null,
      isShowMore: false,
      // ↓ログ用
      viewId: null,
      viewStart: 0,
      activeStart: 0,
      activeTotal: 0,
      viewLeft: false,
      impressionSentFor: null, // 'top7' | 'all'
    };
  },
  computed: {
    // ここで常にストアのrank_dataを参照する
    pens() {
      return this.$store.state.rank_data || [];
    },

    // for文の回数制限をするために配列の長さを変えるよ
    limitCount() {
      return this.pens.slice(0, 7)
    },
    elseCount() {
      return this.pens.slice(7)
    },
    // 検索ID（ストアを探してなければセッションストレージ、なければnull。ストアはまだ実装していないのでセッションストレージ）
    searchId() {
      return this.$store.state.search_id
        || sessionStorage.getItem('last_search_id')
        || null;
    },
  },
  mounted() {
    this.$returnScroll();

    // --- ログ page_view (results) ---
    this.viewId = crypto.randomUUID();
    this.viewStart = performance.now();
    this.activeStart = this.viewStart;
    this.activeTotal = 0;
    fire('page_view', {
      view_id: this.viewId,
      screen: 'results',
      from: getPrevScreen(),
      search_id: this.searchId,
      locale: this.$i18n.locale,
      aquarium: this.aquarium,
    });
    setCurrentScreen('results');

    // ランキングがもう入っていれば top7 表示ログ
    if (this.pens?.length) this.sendImpressionTop7();

    document.addEventListener('visibilitychange', this.onVis);
    window.addEventListener('beforeunload', this.flushLeave, { once: true });

  },
  created() {
    this.$returnScroll();
    // this.pens = this.$store.state.rank_data


    // 直遷移（リロード等）で rank_data が空でも、raw があればローカライズして復元
    const raw = this.$store.state.rank_base_last;
    if ((!this.$store.state.rank_data || this.$store.state.rank_data.length === 0) && raw && raw.length) {
      // 辞書が未ロードのケースに備える
      const loc = localStorage.getItem('locale') || this.$i18n.locale || 'ja';
      this.$store.dispatch('loadPenguinLocale', loc).then(() => {
        this.$store.dispatch('localizeAndSetRankData', raw);
      });
    }
  },
  beforeDestroy() {
    this.flushLeave();
    document.removeEventListener('visibilitychange', this.onVis);
  },
  watch: {
    pens(newPens) {
      if (newPens && newPens.length && this.impressionSentFor !== 'top7') {
        this.sendImpressionTop7();
      }
    },
    // 言語が変わったら：辞書をロード → 直近のランキング base を再ローカライズして反映
    '$i18n.locale': {
      async handler(newLocale) {
        await this.$store.dispatch('loadPenguinLocale', newLocale);
        const raw = this.$store.state.rank_base_last;
        if (raw && raw.length) {
          this.$store.dispatch('localizeAndSetRankData', raw);
        }
      }
    }
  },
  methods: {
    setResultRank(rank) {
      this.result = rank + 1;
      // console.log(this.result);
      const pen = this.pens[rank];
      fire('result_click', {
        search_id: this.searchId,
        penguin_name: pen?.name || pen?.nameLabel || '',
        rank: this.result,
        score: (typeof pen?.score === 'number' ? pen.score : null),
      });
      this.$router.push({ name: "pen-detail", params: { info: this.pens[rank], rank: this.result, all_info: this.pens } });
    },
    notSure() {
      this.result = 0;
      fire('not_sure', { search_id: this.searchId });
    },
    showMore() {
      this.isShowMore = true;
      fire('show_more', {
        search_id: this.searchId,
        from: 7,
        to: 'all',
      });

      // 全件の impression も送る
      const items = (this.pens || []).map((p, idx) => ({
        name: p.name || p.nameLabel || '',
        pos: idx + 1,
        score: (typeof p.score === 'number' ? p.score : null),
      }));
      fire('rank_impression', {
        search_id: this.searchId,
        topN: 'all',
        items,
        // ui_variant: 'A',
      });
      this.impressionSentFor = 'all';
    },
    sendDB(path) {
      // どちらの選択肢かを判定してログ送信
      const choice = (path === 'draw-penguin') ? 'draw_other' : 'go_home';
      fire('not_sure_choice', {
        search_id: this.searchId,
        choice
      });

      //サーバーに保存する作業
      var params = new URLSearchParams();
      params.append("name", this.$store.state.user.name);
      params.append("uid", this.$store.state.user.uid);
      params.append("aquarium", this.aquarium);
      params.append("penname", this.$store.state.penName);
      params.append("bandcolor", JSON.stringify(this.$store.state.bandColor));
      params.append("image", this.$store.state.imgURL);
      params.append("time", this.$store.state.drawTime);
      params.append("data", JSON.stringify(this.$store.state.data));
      params.append("ranking", JSON.stringify(this.pens));
      params.append("part", JSON.stringify(this.$store.state.part));
      params.append("rank", this.result);

      this.$axios
        .post("https://dev.pensaku.com/api/pensaku/post_all.php", params)
        .then((response) => {
          console.log("status:", response.status);
          alert(this.$t('ranking.sent'));
        })
        .catch((error) => {
          alert(this.$t('ranking.alertError'));
          console.log("err:", error);
        });

      this.dialog = false;
      this.$router.push(`/${this.aquarium}/${path}`);
    },
    onVis() {
      const now = performance.now();
      if (document.visibilityState === 'hidden') {
        this.activeTotal += now - this.activeStart;
      } else if (document.visibilityState === 'visible') {
        this.activeStart = now;
      }
    },
    flushLeave() {
      if (!this.viewStart || this.viewLeft) return;
      this.viewLeft = true;
      const now = performance.now();
      const total = now - this.viewStart;
      if (document.visibilityState === 'visible') {
        this.activeTotal += now - this.activeStart;
      }
      fire('page_leave', {
        view_id: this.viewId,
        screen: 'results',
        total_ms: Math.round(total),
        active_ms: Math.round(this.activeTotal),
      });
    },
    sendImpressionTop7() {
      if (!this.pens?.length || this.impressionSentFor === 'top7') return;
      const items = this.pens.slice(0, 7).map((p, i) => ({
        name: p.name || p.nameLabel || '',
        pos: i + 1,
        score: (typeof p.score === 'number' ? p.score : null),
      }));
      fire('rank_impression', {
        search_id: this.searchId,
        topN: 7,
        items,
        // ui_variant: 'A',
      });
      this.impressionSentFor = 'top7';
    },
  }
}
</script>


<style>
.rounded-left {
  border-radius: 23px 0 0 23px;
}

.comment {
  /* overflow-wrap: normal;
  word-break: break-all;
  white-space: normal;
  overflow: hidden; */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;   /* ← 表示する最大行数。必要なら 2 や 4 に変更 */
  overflow: hidden;
  white-space: normal;
  word-break: break-word;  /* 日本語の長文対策 */
}

.reference {
  font-style: italic;
  font-size: 11px;
  color: gray;
}

.item {
  min-width: 0;
}
</style>